import api from "./api.js";

export default class ExcelApi {
  static async getMemberExcel(data) {
    return await api.post(`api/member/excel`, data);
  }
}
